import { getToken } from '@nxtpeople/nxt-vue-keycloak';
import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import router from '../router';

const authRequestInterceptors = async function (config: AxiosRequestConfig) {
   const token = await getToken();
   config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
      Accept: `application/json`,
   };
   return config;
};

const authResponseSuccessInterceptors = async function (response: AxiosResponse) {
   return response;
};

const authResponseErrorInterceptors = async function (error: AxiosError) {
   if (!error.response) return;

   const { status } = error.response;

   if ([401].includes(status)) return router.push({ name: 'error', query: { http_status_code: status } });
   return await Promise.reject(error);
};

const authLandingPageInterceptors = async function (error: AxiosError) {
   if (!error.response) return await Promise.reject(error);
   const { status } = error.response;

   if ([401, 403].includes(status)) return router.push({ name: 'error', query: { http_status_code: status } });
};

export { authLandingPageInterceptors, authRequestInterceptors, authResponseErrorInterceptors, authResponseSuccessInterceptors };
